// A cached (CDN HIT) campaign/team page never runs SetRegionRestrictionCookieMiddleware (it's
// global 'web' middleware, so it only runs when Laravel actually processes the request), so
// cookie_consent_region_restriction can go missing even though cookie consent's UK/EU default
// depends on it. This forces one uncached round trip through the same middleware stack purely to
// get that cookie set, so consent doesn't default to denied just because of a cache hit.
//
// useCookieConsent is mounted more than once per page (e.g. Navigation and
// usePersistTrackingCookies both call it), so this dedupes concurrent callers onto one request.
let inFlight = null;
export const refreshRegionCookie = () => {
    if (!inFlight) {
        inFlight = fetch("/api/v2/region-consent", { credentials: "include" })
            .then(() => undefined)
            .catch(() => undefined)
            .finally(() => {
            inFlight = null;
        });
    }
    return inFlight;
};
